import { captureSentry } from '../../sentry';
import validators from '../validators/validators';

const validate = (
  formId,
  value,
  label,
  rules,
  includeAll,
  setFormFieldMessages
) => {
  let allMessages = [];

  if (!rules || !rules.length) {
    return allMessages;
  }

  for (let i = 0; i < rules.length; i += 1) {
    const { name, ...args } = rules[i];

    try {
      const messages =
        validators[name](value, label, args, formId, setFormFieldMessages) ||
        [];
      allMessages = [...allMessages, ...messages];
    } catch (e) {
      captureSentry(e, { formId, validator: name });
    }

    if (!includeAll && allMessages.length > 0) {
      return allMessages;
    }
  }
  if (allMessages.length > 0) {
    captureSentry(`Validation failed: ${allMessages}`);
  }
  return allMessages;
};

export default validate;
